export default {
  clicked: false,
  listings: [],
  auth: false,
  user: false,
  login: false,
  logout: false,
  section: null
}



// WEBPACK FOOTER //
// ./assets/js/store/state.js